import { Helmet } from "react-helmet-async";

const SITE = "Yayra Glover Organic Inputs";
const DEFAULT_DESC =
  "Premium certified-organic fertilisers and crop protection for Ghanaian farmers. Order online, pay cash on delivery, nationwide.";

export function Seo({ title, description = DEFAULT_DESC, path = "", image, jsonLd }) {
  const fullTitle = title ? `${title} — ${SITE}` : `${SITE} — Organic Farming Solutions, Ghana`;
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const url = `${origin}${path}`;
  const img = image || `${origin}/logo.png`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
